import { FC } from 'react'
import { BrowserRouter } from 'react-router'
import { QueryParamProvider } from 'use-query-params'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
  ReactRouter8Adapter,
  defaultQueryClientConfig,
} from '@signifyd/components'
import AppContainer from './AppContainer'

const queryClient = new QueryClient(defaultQueryClientConfig)

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <QueryParamProvider adapter={ReactRouter8Adapter}>
          <AppContainer />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryParamProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
